import { paymentMethodNumber, paymentMethodNumberFinished } from "../../../constants/commondata";
import { CCLiteCommonFunc } from "../../../utils/commonFunctions";

const PAYMENT_SUPPORT = ['fleetCard', 'cash', 'credit', 'corpCredit', 'directBilling'];

const checkBookCorporateCard = (bookInfo) => {
  const paymentType = bookInfo?.request?.paymentType;
  if (CCLiteCommonFunc.isBookingStatusCompleted(bookInfo?.status))
    paymentType === paymentMethodNumberFinished.corporateCard;
  return paymentType === paymentMethodNumber.corporateCard;
};

export const renderTitleCard = ({ isCorp, card }) => {
  return `${isCorp ? `Corporate Card` : `Personal Card`} - ${
    card?.cardType ? card?.cardType?.toUpperCase() : ''
  } *${card?.cardMask?.slice(-4)}`;
};

export const getPaymentsAvailable = ({ paymentMethodSetting, bookInfo, customer }) => {
  const { corporateTypes = [], individualTypes = [] } = paymentMethodSetting;
  let payment = (
    bookInfo?.travelerType === 1 ? corporateTypes : individualTypes
  ).filter((pm) => PAYMENT_SUPPORT.includes(pm.key));

  if (
    payment.some((pm) => pm.key === 'credit') &&
    customer?.credits?.length > 0
  ) {
    customer?.credits.map((card) => {
      payment.push({
        key: card.localToken,
        type: 'credit',
        userType: 'individual',
        cardType: card?.cardType,
        title: renderTitleCard({ isCorp: false, card }),
        value: card.localToken,
      });
    });
  }

  // customer/corp đã xóa card nhưng trong booking còn lưu.
  const isCorp = checkBookCorporateCard(bookInfo);
  const cardOfBook = isCorp
    ? bookInfo?.corporateInfo?.creditInfo
    : bookInfo?.psgInfo?.creditInfo;
  if (
    cardOfBook?.localToken &&
    !payment.some((c) => c.key === cardOfBook?.localToken)
  ) {
    payment.push({
      key: cardOfBook.localToken,
      type: 'credit',
      value: cardOfBook.localToken,
      userType: isCorp ? 'corporate' : 'individual',
      title: renderTitleCard({ isCorp, card: cardOfBook }),
      ...cardOfBook,
    });
  }

  // luôn luôn thêm 4 offline payment cho booking completed
  // if(CCLiteCommonFunc.isBookingStatusCompleted(bookInfo?.status)) {
  // }
  const offlinePayment = ['cash', 'check', 'wire', 'digitalWallet', 'bankTransfer', 'offlineMethod']
  offlinePayment.forEach(pm => {
    // Kiểm tra xem payment method đã tồn tại chưa để tránh duplicate
    if (!payment.some(existingPm => existingPm.key === pm)) {
      payment.push({
        key: pm,
        type: pm,
        value: pm,
      })
    }
  })

  return payment;
};

export const completedBook_calculateSurcharge = ({
  surchargeBook, // info from get rushHour api call payment
  objFare,
  isFareEdited = false, // KAN-3945
}) => {
  if (isFareEdited) return { totalSurcharge: objFare?.rushHourFee };
  if (!surchargeBook || !objFare) return 0;

  if(!objFare?.actualFare) {
    return {
      surchargeFeeNormal: objFare?.rushHourFee,
      dynamicSurchargeAmount: objFare?.dynamicSurcharge,
      totalSurcharge: objFare?.rushHourFee,
    }
  }
  
  const {
    surchargeParameter = 0,
    surchargeFee = 0,
    surchargeType,
    bookingLeadTimeSurchargeType,
    bookingLeadTimeSurchargeFee = 0,
  } = surchargeBook;
  const surchargeFeeNormal =
    surchargeType === 'amount'
      ? surchargeFee || 0
      : (surchargeFee * (objFare?.basicFare || 0)) / 100;
  const dynamicSurchargeAmount =
    surchargeParameter >= 1
      ? (objFare?.basicFare || 0) * (surchargeParameter - 1)
      : 0;
  const bookingLeadTimeSurcharge =
    bookingLeadTimeSurchargeType === 'amount'
      ? bookingLeadTimeSurchargeFee || 0
      : (bookingLeadTimeSurchargeFee * (objFare?.basicFare || 0)) / 100;
  return {
    surchargeFeeNormal,
    dynamicSurchargeAmount,
    bookingLeadTimeSurcharge,
    totalSurcharge:
      surchargeFeeNormal + dynamicSurchargeAmount + bookingLeadTimeSurcharge,
  };
};